import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PhoneIcon, MenuIcon, XIcon } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#home'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Case Studies',
    href: '#case-studies'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-black/90 backdrop-blur-md border-b border-white/10 py-4' : 'bg-transparent py-6'}`} data-id="element-146">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-147">
        <div className="flex justify-between items-center" data-id="element-148">
          {/* Logo */}
          <a href="#home" className="flex items-center group" data-id="element-149">
            <img src="https://cdn.magicpatterns.com/uploads/78heWmZdxPSksJ4ucoHqqb/Spring_Link.png" alt="SpringLinks Solutions Ltd" className="h-10 sm:h-12 w-auto brightness-0 invert group-hover:opacity-80 transition-opacity duration-300" data-id="element-150" />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-151">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-gray-300 hover:text-brand-primary transition-colors relative group" data-id="element-152">
                {link.name}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-brand-primary transition-all duration-300 group-hover:w-full" data-id="element-153"></span>
              </a>)}
            <a href="tel:+254724570060" className="flex items-center gap-2 bg-brand-primary hover:bg-brand-light text-white px-6 py-2.5 rounded-full text-sm font-semibold transition-all duration-300 hover:glow-blue" data-id="element-154">
              <PhoneIcon className="w-4 h-4" data-id="element-155" />
              Contact Us
            </a>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden text-white p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-156">
            {mobileMenuOpen ? <XIcon data-id="element-157" /> : <MenuIcon data-id="element-158" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav Drawer */}
      <AnimatePresence data-id="element-159">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-brand-black border-b border-white/10 overflow-hidden" data-id="element-160">
            <div className="px-4 py-6 flex flex-col gap-4" data-id="element-161">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="text-lg font-medium text-gray-300 hover:text-brand-primary transition-colors" data-id="element-162">
                  {link.name}
                </a>)}
              <a href="tel:+254724570060" className="flex items-center justify-center gap-2 bg-brand-primary text-white px-6 py-3 rounded-full text-base font-semibold mt-4" data-id="element-163">
                <PhoneIcon className="w-5 h-5" data-id="element-164" />
                +254 724 570 060
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}